import { Typography } from "@material-ui/core";

export default function SectionHeader({ children }) {
  return (
    <Typography
      variant="h3"
      style={{ paddingBottom: "1rem", paddingTop: "0.5rem" }}
    >
      {children}
    </Typography>
  );
}
